export enum AmenityType {
    CommunityAmenity = 1,
    UnitAmenity = 2,
    RentableItem = 3,
    AncillaryItem = 4,
    PricingAmenity = 5,
    Service = 6
}